var _circle, _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFilterBtn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 28,
    r: 28,
    fill: "#f2c37f",
    className: "bg"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 33C14 31.8954 14.8954 31 16 31H40C41.1046 31 42 31.8954 42 33C42 34.1046 41.1046 35 40 35H16C14.8954 35 14 34.1046 14 33Z",
    fill: "#481f0d",
    className: "content"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28 33C28 35.7614 25.7614 38 23 38C20.2386 38 18 35.7614 18 33C18 30.2386 20.2386 28 23 28C25.7614 28 28 30.2386 28 33Z",
    fill: "#481f0d",
    className: "content"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25 33C25 31.8954 24.1046 31 23 31C21.8954 31 21 31.8954 21 33C21 34.1046 21.8954 35 23 35V38C20.2386 38 18 35.7614 18 33C18 30.2386 20.2386 28 23 28C25.7614 28 28 30.2386 28 33C28 35.7614 25.7614 38 23 38V35C24.1046 35 25 34.1046 25 33Z",
    fill: "#481f0d",
    className: "content"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14 22C14 20.8954 14.8954 20 16 20H40C41.1046 20 42 20.8954 42 22C42 23.1046 41.1046 24 40 24H16C14.8954 24 14 23.1046 14 22Z",
    fill: "#481f0d",
    className: "content"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M38 22C38 24.7614 35.7614 27 33 27C30.2386 27 28 24.7614 28 22C28 19.2386 30.2386 17 33 17C35.7614 17 38 19.2386 38 22Z",
    fill: "#481f0d",
    className: "content"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M35 22C35 20.8954 34.1046 20 33 20C31.8954 20 31 20.8954 31 22C31 23.1046 31.8954 24 33 24V27C30.2386 27 28 24.7614 28 22C28 19.2386 30.2386 17 33 17C35.7614 17 38 19.2386 38 22C38 24.7614 35.7614 27 33 27V24C34.1046 24 35 23.1046 35 22Z",
    fill: "#481f0d",
    className: "content"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterBtn);
export default __webpack_public_path__ + "static/media/filter-btn.82a3867426b4afa21cb6692878a1a2c0.svg";
export { ForwardRef as ReactComponent };